export enum TelemetricKind {
  Kilometraje = 'Kilometraje'
}
